import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
	deleteInvoice,
	setDeleteInvoiceDialogOpenStatus,
	setEditInvoiceModalOpenStatus,
} from 'src/redux/slices/purchases'
import LoadingButton from '../Button/LoadingButton'

function PurchaseInvoiceDeleteDialog({ currentPurchaseId }) {
	const dispatch = useDispatch()
	const deleteInvoiceDialogOpenStatus = useSelector(
		(state) => state.purchases.deleteInvoiceDialogOpenStatus
	)
	const deletePurchaseInvoiceApiStatus = useSelector(
		(state) => state.purchases.deletePurchaseInvoiceApiStatus
	)
	const { t } = useTranslation()
	const { t: tPurchases } = useTranslation('purchases')
	const { t: tClientDeleteDialog } = useTranslation('ClientDeleteDialog')

	const handleToggleDeleteDialog = () => {
		dispatch(setDeleteInvoiceDialogOpenStatus({ status: false }))
	}
	const handleDeleteDialog = () => {
		console.log('currentPurchaseId: ', currentPurchaseId)
		dispatch(setEditInvoiceModalOpenStatus({ status: false }))
		dispatch(deleteInvoice({ currentPurchaseId }))
		handleToggleDeleteDialog()
	}
	return (
		<Dialog
			open={deleteInvoiceDialogOpenStatus}
			onClose={(event, reason) => {
				if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
					handleToggleDeleteDialog()
				}
			}}
			aria-labelledby="delete-purchase-invoice-dialog"
		>
			<DialogTitle id="form-dialog-title">
				{tPurchases('deleteInvoiceTitle')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{tPurchases('deleteInvoiceText')}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<LoadingButton
					onClick={handleDeleteDialog}
					color="secondary"
					variant="contained"
					loading={
						deletePurchaseInvoiceApiStatus === 'loading'
							? true
							: false
					}
				>
					{tClientDeleteDialog('yes')}
				</LoadingButton>
				<Button
					onClick={handleToggleDeleteDialog}
					color="primary"
					disabled={
						deletePurchaseInvoiceApiStatus === 'loading'
							? true
							: false
					}
					variant="contained"
				>
					{tClientDeleteDialog('cancel')}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default PurchaseInvoiceDeleteDialog
